export default () => {
    let select = document.getElementById('blogCategoriesSelect');
    if (select) {
        let categoriesSelect = selectInit(select);
    }
}

let selectInit = (select) => {
    select.addEventListener('change', () => {
        if (select.value !== 'default') {
            window.location.href = select.value;
        }
    });
};
